import TomSelectBaseController from "./tom_select_base";

// Picks an intervention from the campus Intervention Menu while logging a
// follow-up. Options are grouped by tier and show it inline; typing a name
// that is not on the menu offers to create it, and only then does the tier
// select appear -- an intervention already on the menu brings its own tier.
//
// In the follow-up sidebar the picker sits at the bottom of the page, so its
// dropdown opens upward rather than running off it.
export default class extends TomSelectBaseController {
  static targets = ["select", "tierField", "tier", "note"];
  static values = { dropUp: { type: Boolean, default: true } };

  connect() {
    super.connect();
    this.tomSelect.wrapper.classList.add("ts-intervention-picker");
    if (this.dropUpValue) this.tomSelect.wrapper.classList.add("ts-drop-up");
    this.tomSelect.dropdown.insertAdjacentHTML(
      "beforeend",
      '<div class="ts-dropdown-footer">Scroll for more, or type to search</div>',
    );
    this.toggleTier(this.tomSelect.getValue());
  }

  get selectElement() {
    return this.selectTarget;
  }

  get tomSelectOptions() {
    const controller = this;

    return {
      create: true,
      maxOptions: null,
      lockOptgroupOrder: true,
      onItemAdd: (value) => this.toggleTier(value),
      onItemRemove: () => this.toggleTier(null),
      render: {
        option: (data, escape) => controller.renderEntry(data, escape),
        item: (data, escape) => controller.renderEntry(data, escape),
        option_create: function (data, escape) {
          const noMatches =
            this.currentResults?.items?.length === 0
              ? '<div class="text-xs text-zinc-500 mb-1">No matches in your campus menu</div>'
              : "";
          return `<div class="create">${noMatches}+ Create "${escape(
            data.input,
          )}"</div>`;
        },
        // Once something is typed the create option says it all.
        no_results: function () {
          return this.inputValue()
            ? null
            : '<div class="no-results">Your campus menu is empty. Type to add an intervention.</div>';
        },
      },
    };
  }

  renderEntry(data, escape) {
    // TomSelect copies each option's data-* attributes on, camelCased.
    const badge = data.menu
      ? `<span class="ts-tier-pill ts-tier-pill--${escape(data.tier)}">${escape(
          data.tierLabel,
        )}</span>`
      : '<span class="text-xs font-bold text-primary-500">NEW</span>';

    return `<div class="flex items-center justify-between gap-2"><span>${escape(
      data.text,
    )}</span>${badge}</div>`;
  }

  // A brand-new intervention needs a tier for the menu; an existing one does not.
  toggleTier(value) {
    const option = value ? this.tomSelect.options[value] : null;
    const isNew = Boolean(option && !option.menu);

    this.tierFieldTarget.hidden = !isNew;
    this.noteTarget.hidden = !isNew;
    this.tierTarget.disabled = !isNew;
    if (!isNew) this.tierTarget.value = "";
  }
}
